import Layout from "components/layout";
import { Footer } from "components/layout/Footer";
import { Button } from "features/lp/2/components/Button";
import { PriceInfo } from "features/lp/2/components/PriceInfo";
import { signIn } from "next-auth/client";
import { useRouter } from "next/router";
import QueryString from "qs";
import { ReactNode, useCallback, useEffect, useState } from "react";
import { Image } from "shared/components/atoms/Image";
import { useDeviceInfo } from "shared/hooks/useDeviceInfo";
import { commonErrorMessage } from "shared/hooks/useErrorMessage";
import { useFlashContext } from "shared/hooks/useFlashContext";
import { useHostName } from "shared/hooks/useHostName";
import useLocalStorage from "shared/hooks/useLocalStorage";
import tw from "twin.macro";
import { Paths } from "utils/routes";

const LP84 = () => {
  const [disabled, setDisabled] = useState(false);

  const { query } = useRouter();
  const { setItemAsString, keys } = useLocalStorage();
  const { toggleFlash } = useFlashContext();
  const { deviceInfo } = useDeviceInfo();
  const { host } = useHostName();

  const onClick = useCallback(async () => {
    setDisabled(true);
    const { pathname, query } = Paths.callbacks.line.fromLP2();
    const queries = QueryString.stringify(query);
    const callbackUrl = `${host}${pathname}?${queries}`;
    try {
      await signIn("line", { callbackUrl });
    } catch {
      toggleFlash({ message: commonErrorMessage });
    } finally {
      setDisabled(false);
    }
  }, [setDisabled, toggleFlash, host]);

  useEffect(() => {
    if (!query.clid) return;
    setItemAsString(keys.clid, query.clid);
  }, [keys.clid, query.clid, setItemAsString]);

  return (
    <div
      tw="relative"
      css={!deviceInfo?.device.isMobile && tw`max-w-md mx-auto`}
    >
      <Image
        src={`${process.env.NEXT_PUBLIC_CDN_V2}/lp/2/first-view.png`}
        width={750}
        height={772}
        layout="responsive"
        unoptimized
      />
      <div tw="relative" css={{ marginTop: "-7%", marginBottom: "-7%" }}>
        <Image
          src={`${process.env.NEXT_PUBLIC_CDN_V2}/lp/2/second-view-bg.png`}
          width={750}
          height={1426}
          layout="responsive"
          unoptimized
        />
        <div tw="absolute top-0 w-full">
          <Button
            onClick={onClick}
            disabled={disabled}
            css={{ marginTop: "26%" }}
          />
          <div tw="font-hira-mincho font-semibold text-[22px] leading-8 text-white text-center mt-2">
            解決できない悩みを
            <br />
            1人で抱えていませんか？
          </div>
        </div>
        <div tw="relative">
          <Image
            src={`${process.env.NEXT_PUBLIC_CDN_V2}/lp/2/popular-fortune-tellers.png`}
            width={750}
            height={2008}
            layout="responsive"
            unoptimized
          />
          <Button
            onClick={onClick}
            disabled={disabled}
            tw="absolute -bottom-12 z-10"
          />
        </div>
        <Image
          src={`${process.env.NEXT_PUBLIC_CDN_V2}/lp/2/safety.png`}
          width={750}
          height={948}
          layout="responsive"
          unoptimized
        />
        <PriceInfo onClick={onClick} disabled={disabled} />
        <Image
          src={`${process.env.NEXT_PUBLIC_CDN_V2}/lp/2/common-qa.png`}
          width={750}
          height={1008}
          layout="responsive"
          unoptimized
        />
        <div tw="bg-[#160847] py-[53px]">
          <p tw="font-hira-mincho font-semibold text-[21px] tracking-[1.05px] leading-8 text-white text-center">
            電話占いミラーは
            <br />
            豊富な占い師数によって、
            <br />
            多くのお客様に支持されています。
          </p>
          <Button onClick={onClick} disabled={disabled} tw="mt-10" />
        </div>
      </div>
      <Footer />
    </div>
  );
};

LP84.getLayout = (page: ReactNode) => {
  return (
    <Layout header={null} footer={null} nav={null} channelTalk={null}>
      {page}
    </Layout>
  );
};

export default LP84;
